import React, {useContext} from 'react';
import "./rnd.scss";
import { AppContext } from '../../services/translationContext';
import { Link, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { PageHero } from '../../components/page-hero/page-hero';
import SeoHelmet from '../../components/SeoHelmet';

export const RnD = () => {
  const { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);

  const pageTitle = `R&D | ${TranslationsService.getMainInfoCompany('name')}`;
  const pageDescription = TranslationsService.labels('hero_sections.rnd.text');
  const pageUrl = `https://www.sydea.com/${lang}/about/rnd`;

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "R&D",
    description: pageDescription,
    url: pageUrl
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.about.label`), item: `https://www.sydea.com/${lang}/about` },
      { "@type": "ListItem", position: 3, name: "R&D", item: pageUrl }
    ]
  };


  return (
    <div className="section-home light">
      <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels('hero_sections.rnd.img_path')}
        schema={[webPageSchema, breadcrumbSchema]}
      />
      <PageHero
        bgImage={TranslationsService.labels('hero_sections.rnd.img_path')}
        breadcrumb={[
           { label: TranslationsService.labels(`menu.about.label`), path: 'about' }
        ]}
        title='R&D'
        subtitle={TranslationsService.labels(`hero_sections.rnd.text`)}
      />

      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(TranslationsService.labels('rnd_text')) }} className='syd-body-article-p m-3 p-3'></div>

    </div>
  );
};

